<template>
  <v-layout>
    <v-flex pa-3>
      <h1>Dilapay</h1>
      <br>
      <v-flex
        xs12
        py-6
      >
        <v-card>
          <v-card-title
            class="pb-4 d-flex justify-space-between"
            style="border-bottom: 1px solid #eee"
          >
            <h2 class="title primary--text">Calcolo utile</h2>
          </v-card-title>
          <v-card-text class="pt-5">
            <v-text-field
              outlined
              label="Pagato"
              append-icon="mdi-currency-eur"
            ></v-text-field>

            <v-text-field
              outlined
              label="Ricarco"
              append-icon="mdi-currency-eur"
            ></v-text-field>

            <v-text-field
              outlined
              label="Prezzo al Pubblico"
              append-icon="mdi-currency-eur"
            ></v-text-field>

            <v-text-field
              outlined
              label="Numero rate"
              append-icon="mdi-counter"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-flex class="ma-2 text-right">
              <v-btn color="primary">Reset</v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {

  }
</script>

<style>
</style>